import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { factory, Flex, List, Text, useProps } from '@coveord/plasma-mantine';
import { IconCircleCheckFilled } from '@coveord/plasma-react-icons';
import { usePrerequisitesListContext } from './PrerequisitesList.context.js';
var defaultProps = {};
var ListItemIcon = function ListItemIcon(param) {
    var status = param.status, stylesApiProps = param.stylesApiProps;
    var ctx = usePrerequisitesListContext();
    if (status === 'success') {
        return /*#__PURE__*/ _jsx(Flex, {
            align: "center",
            children: ctx.iconSuccess || /*#__PURE__*/ _jsx(IconCircleCheckFilled, _object_spread_props(_object_spread({}, ctx.getStyles('iconSuccess', stylesApiProps)), {
                height: 16
            }))
        });
    }
    return /*#__PURE__*/ _jsx(Flex, {
        align: "center",
        children: ctx.iconFailure || /*#__PURE__*/ _jsx(IconCircleCheckFilled, _object_spread_props(_object_spread({}, ctx.getStyles('iconFailure', stylesApiProps)), {
            height: 16
        }))
    });
};
export var PrerequisitesListItem = factory(function(_props, ref) {
    var ctx = usePrerequisitesListContext();
    var props = useProps('PrerequisitesListItem', defaultProps, _props);
    var status = props.status, children = props.children, className = props.className, classNames = props.classNames, styles = props.styles, style = props.style, _vars = props.vars, others = _object_without_properties(props, [
        "status",
        "children",
        "className",
        "classNames",
        "styles",
        "style",
        "vars"
    ]);
    var stylesApiProps = {
        classNames: classNames,
        styles: styles
    };
    return /*#__PURE__*/ _jsx(List.Item, _object_spread_props(_object_spread({
        ref: ref
    }, others, ctx.getStyles('listItem', _object_spread_props(_object_spread({}, stylesApiProps), {
        className: className,
        style: style
    }))), {
        icon: status !== 'static' && /*#__PURE__*/ _jsx(ListItemIcon, {
            status: status,
            stylesApiProps: stylesApiProps
        }),
        children: /*#__PURE__*/ _jsx(Text, _object_spread_props(_object_spread({
            size: "xs"
        }, ctx.getStyles('listItemText', stylesApiProps)), {
            children: children
        }))
    }));
});

//# sourceMappingURL=PrerequisitesListItem.js.map